import { config } from '@fortawesome/fontawesome-svg-core';
/* POLIFYLS */
import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
/* POLIFYLS */
/* CSS */
import 'bootstrap-css-only/css/bootstrap.min.css';
import 'devextreme/dist/css/dx.common.css';
import './../Css/dx.light.custom.css';
import '@fortawesome/fontawesome-svg-core/styles.css';
import './../Css/body.css';
import './../Css/common.css';
import './../Css/footer.css';
import './../Css/header.css';
import './../Css/info-bar.css';
import './../Css/menu.css';
import './../Css/overrides.css';
import './../Css/top-bar.css';
import './../Css/effects.css';
import './../Css/loading.css';
import './../Css/timeline-wrapper.css';
/* CSS */
/**Disable fontawesome auto css import (breaks csp policy) */
config.autoAddCss = false;
//# sourceMappingURL=CriticalImports.js.map